import { Popover as AntPopover } from 'antd';
import styled from 'styled-components';
import { Form as FormAtom } from 'components/atoms/form';
import { RTE } from 'components/atoms/rte';

export const Popover = styled(AntPopover)`
  & .ant-popover-content {
    min-height: 300px;
  }
`;

export const Rte = styled(RTE)`
  --rte-background: var(--coolest-gray-10);
`;

export const Form = styled(FormAtom)`
  padding-top: var(--layout-04);
`;

export const SelectContainer = styled.div`
  min-height: 350px;
  width: 320px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: var(--layout-01);
`;

export const Col = styled.div`
  display: flex;
  width: 160px;
  overflow: hidden;
  flex-direction: column;
  &:not(:last-child) {
    margin-right: var(--layout-01);
  }
`;

export const Footer = styled.div`
  display: flex;
  padding: var(--spacing-05) 0 var(--spacing-07) 0;
`;

export const Container = styled.div`
  padding-top: var(--spacing-09);
`;
